import {
  CorrectiveInvoice,
  Invoice,
  InvoiceLine,
} from 'pages/invoices/invoices.types';
import {
  isForeignInvoice,
  recalculateCorrectedTotals,
  recalculatePreviousTotals,
  recalculateTotals,
} from 'utils/invoiceFunctions.utils';

export const prepareRemoveInvoiceLinePayload = (
  invoice: Invoice,
  invoiceLine: InvoiceLine,
) => {
  const updatedInvoiceLines = invoice.invoiceLines.filter(
    (line) => line.id !== invoiceLine.id,
  );
  const updatedInvoice = { ...invoice, invoiceLines: updatedInvoiceLines };
  const { createdFrom, ...recalculatedInvoice } = recalculateTotals({
    ...updatedInvoice,
  });

  if (!isForeignInvoice(invoice.invoiceClass)) {
    recalculatedInvoice.totals.netValueAllocationSum =
      recalculatedInvoice.totals.netValueAllocationSum -
      invoiceLine.amounts.netValue;
  }

  const payload = {
    ...recalculatedInvoice,
    __type: 'Invoice',
    buyerCounterparty: {
      id: recalculatedInvoice.buyerCounterparty.id,
    },
    currencyCode: {
      id: recalculatedInvoice.currencyCode.id,
    },
    sellerCounterparty: {
      id: recalculatedInvoice.sellerCounterparty.id,
    },
    ...(recalculatedInvoice.owner && {
      owner: {
        id: recalculatedInvoice.owner.id,
      },
    }),
  };

  return payload;
};

export const prepareRemoveCorrectiveInvoiceLinePayload = (
  invoice: CorrectiveInvoice,
  invoiceLine: InvoiceLine,
  isLinePrevious: boolean,
) => {
  let recalculatedInvoiceFull;

  if (isLinePrevious) {
    const updatedPreviousInvoiceLines = invoice.previousInvoiceLines.filter(
      (line) => line.id !== invoiceLine.id,
    );
    const updatedInvoice = {
      ...invoice,
      previousInvoiceLines: updatedPreviousInvoiceLines,
    };
    recalculatedInvoiceFull = recalculatePreviousTotals({
      ...updatedInvoice,
    });
  } else {
    const updatedCorrectedInvoiceLines = invoice.correctedInvoiceLines.filter(
      (line) => line.id !== invoiceLine.id,
    );
    const updatedInvoice = {
      ...invoice,
      correctedInvoiceLines: updatedCorrectedInvoiceLines,
    };
    recalculatedInvoiceFull = recalculateCorrectedTotals({
      ...updatedInvoice,
    });
  }

  const { createdFrom, ...recalculatedInvoice } = recalculatedInvoiceFull;

  const payload = {
    ...recalculatedInvoice,
    __type: 'CorrectiveInvoice',
    buyerCounterparty: {
      id: recalculatedInvoice.buyerCounterparty.id,
    },
    currencyCode: {
      id: recalculatedInvoice.currencyCode.id,
    },
    sellerCounterparty: {
      id: recalculatedInvoice.sellerCounterparty.id,
    },
    ...(recalculatedInvoice.owner && {
      owner: {
        id: recalculatedInvoice.owner.id,
      },
    }),
  };

  return payload;
};
